import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnDestroy,
  Output
} from '@angular/core';
import ProjectHelper from 'src/app/helpers/project-helper';
import { TemporaryMaterialChoices } from 'src/app/model/product/windowsticker/windowsticker';
import { Adjustment } from 'src/app/model/project/adjustment';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'general-internal-adjustment',
  templateUrl: './general-internal-adjustment.component.html',
  styleUrls: ['./general-internal-adjustment.component.scss']
})
export class GeneralInternalAdjustmentComponent implements OnInit, OnDestroy {
  @Input()
  public project: Project;

  @Input()
  public adjustment: Adjustment;

  @Output()
  public output = new EventEmitter<any>();

  temporaryMaterialOptions: any[];
  temporaryMaterialChanged = new EventEmitter<any>();

  baseProjectPlacementInfo: string;
  init: boolean = false;

  constructor() {
    this.temporaryMaterialOptions = [
      TemporaryMaterialChoices.TEMPORARY,
      TemporaryMaterialChoices.PERMANENT
    ];
  }

  ngOnInit() {
    this.calculateBaseProjectPlacementInfo();
    this.init = true;
  }

  calculateBaseProjectPlacementInfo() {
    const baseProject = ProjectHelper.getBaseProject(this.project);
    this.baseProjectPlacementInfo =
      baseProject != null && baseProject.projectPlacement != null
        ? baseProject.projectPlacement.extraPlacementInfo
        : null;
  }

  ngOnDestroy(): void {
    this.temporaryMaterialChanged.complete();
  }

  setAdjustmentMaterial(value) {
    this.adjustment.material = value;
    this.output.emit();
  }

  amountDesignChange(value) {
    this.adjustment.amountDesign = value;
    this.output.emit();
  }

  setAdjustmentSize(value) {
    this.adjustment.size = value;
    this.output.emit();
  }

  extraInfoDesignChanged(value) {
    this.adjustment.extraInfoDesign = value;
    this.output.emit();
  }

  withPlacementNotesChanged(value) {
    this.adjustment.withPlacementNotes = value;
    this.output.emit();
  }
}
